<template>
  <div>
    <div class="sku-info">
      <template v-if="goodsItem.skuInfo?.length">
        <div class="new-sku-box">
          <div class="left">
            <div class="item" v-for="(item, index) in goodsItem.skuInfo" :key="item">
              <div class="title">
                <span>规格{{ index + 1 }}&nbsp;</span>
                <span>
                  <i v-show="getIsRequiredSku(item)" class="is-measure-required-flag">*</i>
                  {{ item.property_name }}
                </span>
                <a-tag color="blue" class="sku-num">{{ item.values.length }}个</a-tag>
              </div>
              <div class="content">
                <div class="skus">
                  <div
                    class="item"
                    :style="{ maxWidth: goodsItem.IsMeasure && item.measureTemplateList?.length ? '507px' : '142px' }"
                    v-for="(input, inputIndex) in item.values"
                    :key="input"
                  >
                    <ImageItem
                      v-if="!index && item.images?.[inputIndex]"
                      :item="item.images[inputIndex]"
                      :index="inputIndex"
                      :showDeleteIcon="false"
                      @cropper="showVueCropper"
                      @upload="showUploadComponent"
                    />
                    <div class="sku-box">
                      <template v-if="getCanUpdateSku(item.property_name) && !item.measureTemplateList?.length">
                        <a-textarea
                          v-if="typeof input.value_name !== 'object'"
                          v-model:value="input.value_name"
                          style="width: 100%"
                          placeholder="请输入规格值（必填项）"
                          :auto-size="{ minRows: 1, maxRows: 2 }"
                          :class="{ error: !input.value_name || input.errMsg }"
                          @blur="changeSkuName(input, index, inputIndex)"
                        />
                        <span v-if="input.errMsg" style="color: red; font-size: 13px">{{ input.errMsg }}</span>
                      </template>
                      <template v-else-if="!item.measureTemplateList?.length">
                        <div class="select-box">
                          <span v-show="input.top_value_name && !item.isAutoAdd" class="top-sku-value">
                            &nbsp;{{ input.top_value_name }}
                          </span>
                          <div>
                            <a-select
                              style="min-width: 140px"
                              show-search
                              :filter-option="filterSkuOption"
                              placeholder="选择值 (必选项)"
                              v-model:value="input.value_id"
                              :class="{ error: !input.value_id || input.errMsg }"
                              :getPopupContainer="getPopupContainer"
                              @change="
                                changeSkuOption(input, getSkuSelectOptions(item.property_name), index, inputIndex)
                              "
                            >
                              <a-select-option
                                v-for="option in getSkuSelectOptions(item.property_name, item.values)"
                                :value="option.PropertyValueId"
                                :key="option.PropertyValueId"
                                :disabled="option.disabled"
                              >
                                {{ option.PropertyValueName }}
                              </a-select-option>
                            </a-select>
                            <span v-if="input.errMsg" style="color: red; font-size: 13px">{{ input.errMsg }}</span>
                          </div>
                        </div>
                      </template>
                      <a-tooltip>
                        <template #title>删除规格值{{ input.value_name }}</template>
                        <CloseCircleOutlined @click="deleteSku(item, input.value_name, inputIndex, index)" />
                      </a-tooltip>
                    </div>
                  </div>
                  <a-button
                    v-show="goodsItem.IsMeasure || goodsItem.PartSkuNoCompare"
                    type="primary"
                    @click="addSkuValue(item, index)"
                    >添加</a-button
                  >
                </div>
              </div>
            </div>
          </div>
          <NoCompareListTable
            v-if="(goodsItem.IsMeasure || goodsItem.PartSkuNoCompare) && goodsItem.noCompareSkuList?.length"
            :list="goodsItem.noCompareSkuList"
          />
        </div>
        <div class="item">
          <div class="title">
            <span>
              SKU数据 &nbsp;&nbsp;
              <a-tag color="blue" style="font-size: 14px"> {{ tableInfo.list.length }}个 </a-tag>
              <span v-if="false && goodsItem.skuMaxStockNumMsg" style="margin-left: 2em; color: red">
                {{ goodsItem.skuMaxStockNumMsg }}
              </span>
            </span>
          </div>
          <Table :info="tableInfo" class="sku-data-table">
            <template #skuName="{ record }">
              <span>
                {{ record.sell_properties[0].value_name }}
                <template v-if="record.sell_properties[1]?.value_name">
                  - {{ record.sell_properties[1].value_name }}
                </template>
                <template v-if="record.sell_properties[2]?.value_name">
                  - {{ record.sell_properties[2].value_name }}
                </template>
              </span>
            </template>
            <template #originPrice="{ record }">
              {{ record.origin_price }}
            </template>
            <template #priceTitle>
              <a-space>
                价格&nbsp;
                <a-button type="primary" ghost size="small" @click.stop="showUpdateSkuDataModal('价格')"
                  >批量改
                </a-button>
              </a-space>
            </template>
            <template #price="{ record }">
              <a-input-number
                v-model:value="record.price"
                :min="0"
                :step="0.1"
                :precision="2"
                placeholder="输入价格（必填项）"
                :class="{ error: !record.price }"
              />
            </template>
            <template #originStockNum="{ record }">
              {{ record.origin_stock_num || record.origin_stock || 0 }}
            </template>
            <template #stockNumTitle>
              <a-space>
                库存&nbsp;
                <a-button type="primary" ghost size="small" @click.stop="showUpdateSkuDataModal('库存')"
                  >批量改</a-button
                >
              </a-space>
            </template>
            <template #stockNum="{ record }">
              <a-input-number
                v-model:value="record.stock_num"
                :min="0"
                :step="1"
                placeholder="输入库存 (可不填)"
                :class="{ error: !record.stock_num }"
              />
            </template>
          </Table>
        </div>
      </template>
    </div>
    <UpdateSkuDataModal ref="updateSkuDataModal" @update="updateSkuData" />
    <UploadImage :id="uploadId + goodsItem.index" :imgFile="imgFile" @upload-image="showVueCropper" v-show="false" />
    <a-modal
      width="900px"
      v-model:visible="visible"
      title="裁剪图片"
      :footer="false"
      style="top: 60px; z-index: 9999999"
      class="header-fixed-modal"
    >
      <CropperImageModal :imgFile="imgFile" @close="visible = false" @cropper="cropperSuccess" />
    </a-modal>
  </div>
</template>
<script>
import { CloseCircleOutlined } from "@ant-design/icons-vue";
import ImageItem from "../image_item";
import CropperImageModal from "../vue_cropper";
import UpdateSkuDataModal from "./update_sku_data_modal";
import tableHandler from "./table_info";
import handler from "./handler";
import UploadImage from "../upload_image";
import { ShowUploadComponent } from "../utils";
import NoCompareListTable from "./no_compare_list_table";
export default {
  components: {
    CloseCircleOutlined,
    ImageItem,
    CropperImageModal,
    UpdateSkuDataModal,
    UploadImage,
    NoCompareListTable,
  },
  data() {
    return {
      goodsItem: {},
      visible: false,
      imgFile: { index: -1 },
      uploadId: "sku-info-upload-image",
      tableInfo: {
        page: 1,
        pageSize: 10000,
        hideOnSinglePage: true,
        loading: false,
        list: [],
        columns: tableHandler.columns,
        total: 0,
        tableScroll: { y: 450 },
        renderSlot: ["skuName", "price", "priceTitle", "stockNum", "stockNumTitle", "originPrice", "originStockNum"],
        showTotal: (total) => `共 ${total} 个规格数据`,
        rowSelection: null,
        rowKey: "outer_sku_id",
      },
    };
  },
  computed: {
    getCanUpdateSku() {
      return (name) => {
        const findItem = this.goodsItem.canSelectPropertyList.find((item) => item.PropertyName === name);
        return !this.goodsItem.canSelectPropertyList?.length || !findItem || findItem?.SupportDiy;
      };
    },
    getSkuSelectOptions() {
      return (name, values) => {
        const item = this.goodsItem.canSelectPropertyList.find((item) => item.PropertyName === name);
        if (!values) return item?.PropertyList || item?.MeasureTemplateList;
        item?.PropertyList.map((op) => {
          op.disabled = values.some((obj) => obj.value_name === op.PropertyValueName) ? true : false;
        });
        return item?.PropertyList || [];
      };
    },
    getIsRequiredSku() {
      return (sku) => {
        return this.goodsItem.canSelectPropertyList?.find((item) => item.PropertyName === sku.property_name)
          ?.IsRequired;
      };
    },
  },
  methods: {
    // 删除Sku
    deleteSku(item, value, index, level) {
      // 如果是主规格或者是必传的规格，并且删除之前只有1个规格了，那么是不能删除的
      if ((!level || this.getIsRequiredSku(item)) && item.values?.length === 1)
        return this.$message.warning("至少要保留1个规格值 !!!");
      handler.DeleteSku(this, item, value, index, level);
    },
    // 改变Sku的名称时触发
    changeSkuName(obj, level, index) {
      handler.CheckSkuIsRepeat(this.goodsItem.skuInfo[level], obj.value_name, index);
      handler.ChangeSkuName(this, level, obj);
    },
    // 显示修改Sku的价格/库存弹出框
    showUpdateSkuDataModal(title) {
      handler.ShowUpdateSkuDataModal(this, title);
    },
    // 修改Sku数据
    updateSkuData(data) {
      handler.UpdateSkuData(this, data);
    },
    showVueCropper(obj) {
      this.visible = true;
      this.imgFile = obj;
    },
    cropperSuccess(imgUrl) {
      if (this.imgFile.index === -1) {
        this.$refs.addSkuModal.sku.img = imgUrl;
        return (this.visible = false);
      }
      const obj = this.goodsItem.skuInfo[0].images[this.imgFile.index];
      obj.img = imgUrl;
      const imageElement = new Image();
      imageElement.src = imgUrl;
      imageElement.onload = () => {
        obj.width = imageElement.width;
        obj.height = imageElement.height;
        obj.isUpdate = true;
      };
      this.visible = false;
      this.imgFile.index = -1;
      this.$message.success("已成功完成裁剪图片");
    },
    showUploadComponent(obj) {
      ShowUploadComponent(this, obj);
    },
    // 改变sku规格值时触发 (select 规定的选项)
    changeSkuOption(sku, skuList, level, index) {
      sku.value_name = skuList.find((item) => item.PropertyValueId === sku.value_id)?.PropertyValueName;
      this.changeSkuName(sku, level, index);
    },
    // 搜索sku规格值
    filterSkuOption(input, option) {
      return option.children[0].children.toLowerCase().includes(input.toLowerCase());
    },
    // 指定下拉框的父元素
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode;
    },
    // 添加规格值
    addSkuValue(item, index) {
      handler.AddSkuValue(this, item, index);
    }
  },
  watch: {
    "goodsItem.skuInfo"() {
      this.tableInfo.list = this.goodsItem.skuList || [];
    },
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
